import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  computed,
  DestroyRef,
  effect,
  ElementRef,
  inject,
  input,
  OnInit,
  output,
  signal,
  ViewChild,
} from "@angular/core";
import {
  _AbcButtonComponent,
  AbcPopupComponent,
} from "@barthauer/abc/ui-components";
import { RequestPopUp } from "./request-popup/request-popup.component";
import { ActionIcon } from "./enums";
import { DataService } from "../../../../services/data.service";
import { CommonModule } from "@angular/common";
import { DxToolbarModule, DxTooltipModule } from "devextreme-angular";
import { MeasureProgress } from "@barthauer/custom/xmt-models";
import { ApprovalRequestService } from "./approval-request.service";
import { CheckPermissionDirective } from "../../../../directives/check-permession-directive";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ApprovalStepViewModel } from "../../../../view-models/approvalStep.view-model";
import {
  ActionType,
  PermissionContext,
} from "../../../../models/enumeration-list.model";
import { AbcTooltipDirective } from "libs/abc/ui-components/src/lib/core/src/abc-tooltip.directive";
@Component({
  selector: "ubt-geods-approval-request",
  templateUrl: "./approval-request.component.html",
  styleUrls: ["./approval-request.component.scss"],
  imports: [
    _AbcButtonComponent,
    AbcPopupComponent,
    RequestPopUp,
    CommonModule,
    DxToolbarModule,
    CheckPermissionDirective,
    DxTooltipModule,
  ],
  providers: [ApprovalRequestService],
})
export class ApprovalRequest implements OnInit {
  protected measureProgress = input<MeasureProgress | null>(null);
  protected readonly maturityLevelChanged = output<string>();
  @ViewChild("requestPopUp") public requestPopUp: AbcPopupComponent;
  @ViewChild("requestPopUpContent") public requestPopUpContent: RequestPopUp;
  public PermissionContext = PermissionContext;
  public ActionType = ActionType;
  private readonly dataService = inject(DataService);
  private readonly approvalRequestService = inject(ApprovalRequestService);
  private readonly destroyRef = inject(DestroyRef);
  protected res: (key: string, ...value: string[]) => string =
    this.dataService.res;
  protected maturityLevel = signal("HG1"); //Default Value whene there's no matuirty level set
  protected nextMaturityLevel = computed(() =>
    this.approvalRequestService.nextMaturityLevel(this.maturityLevel()),
  );
  protected readonly maxMaturityLevel = "HG5";
  protected isTimeline = signal(false);
  protected readonly timeIcon = ActionIcon.TIME;
  protected actionIcon = "";
  protected userRole: string;
  protected action = "";
  protected lastStep: ApprovalStepViewModel = null;
  protected permission = "";
  protected permissions = this.approvalRequestService.permissions;
  protected isViewerMode = signal(true);
  protected isActiveRequest = signal(false);

  constructor() {
    effect(() => {
      if (this.measureProgress()) {
        this.maturityLevel.set(this.measureProgress().MaturityLevel ?? "HG1");
        this.getApprovalRequests();
      }
    });
  }

  ngOnInit(): void {
    this.initializeUserRoleAndPermission();
    this.updateLastStepConfigurations();
    this.getApprovalRequests();

  }

  protected openRequestPopUp(isTimeline: boolean = false): void {
    this.isTimeline.set(isTimeline);
    this.requestPopUp.instance.show();
  }

  protected onRequestPopupHiding(): void {
    if (!this.isTimeline()) {
      this.requestPopUpContent.clearForm();
    }
    this.requestPopUpContent.timelineScrollView.instance.scrollTo(0);
  }

  protected closeRequestPopup(): void {
    this.requestPopUp.instance.hide();
  }

  protected format(): string {
    return this.approvalRequestService.format(this.lastStep?.Status);
  }

  protected verifyNewStep(): void {
    this.isViewerMode.set(this.applyViewerMode());
    this.isActiveRequest.set(this.verifyRecentRequest());
  }

  protected updateMaturityLevel(value: string): void {
    this.maturityLevel.set(value);
    this.maturityLevelChanged.emit(value);
  }
  private initializeUserRoleAndPermission(): void {
    this.userRole = this.dataService.getRole()[0];
    this.permission =
      this.approvalRequestService.getApprovalProcessPermission();
  }

  private updateLastStepConfigurations(): void {
    this.approvalRequestService.stepAdded$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((step) => {
        this.lastStep = step;
        ({ icon: this.actionIcon, text: this.action } =
          this.approvalRequestService.setIconAndTextRoleBased(
            this.permission,
            this.lastStep,
          ));
        this.isViewerMode.set(this.applyViewerMode());
        this.isActiveRequest.set(this.verifyRecentRequest());
      });
  }

  private getApprovalRequests(): void {
    this.approvalRequestService
      .getApprovalRequests(this.measureProgress()?.Id)
      .subscribe({
        next: (data) => {
          let steps = [];
          this.lastStep = null;
          if (Array.isArray(data) && data.length > 0) {
            steps = this.approvalRequestService.getFormattedSteps(data);
            this.lastStep = steps[0];
          }
          this.approvalRequestService.emitSteps(steps);

          this.approvalRequestService.emitNewStep(this.lastStep);
        },
      });
  }

  private verifyRecentRequest(): boolean {
    return this.approvalRequestService.verifyRecentRequest(this.lastStep);
  }

  private applyViewerMode(): boolean {
    return this.approvalRequestService.applyViewerMode(
      this.measureProgress()?.Id,
      this.maturityLevel(),
      this.maxMaturityLevel,
      this.permission,
      this.lastStep,
    );
  }
}
